// Context for feature flags that take into accound brand config values and cookie values

import React, { createContext, useContext } from 'react'
import PropTypes from 'prop-types'

const FeatureFlagContext = createContext()

const FeatureFlagContextProvider = ({ children, values }) => {
  return <FeatureFlagContext.Provider value={values}>{children}</FeatureFlagContext.Provider>
}

FeatureFlagContextProvider.propTypes = {
  children: PropTypes.node,
  values: PropTypes.object
}

// For class components
const FeatureFlagContextConsumer = ({ children }) => {
  return (
    <FeatureFlagContext.Consumer>
      {context => {
        if (context === undefined) {
          throw new Error('FeatureFlagContextConsumer must be used within a FeatureFlagContextProvider')
        }
        return React.Children.map(children, child =>
          React.cloneElement(child, {
            ...context
          })
        )
      }}
    </FeatureFlagContext.Consumer>
  )
}

FeatureFlagContextConsumer.propTypes = {
  children: PropTypes.node
}

// For Functional Components
const useFeatureFlagContext = () => {
  const context = useContext(FeatureFlagContext)
  if (context === undefined) {
    throw new Error('useFeatureFlagContext must be used within a FeatureFlagContextProvider')
  }
  return context
}

export { FeatureFlagContext, FeatureFlagContextProvider, FeatureFlagContextConsumer, useFeatureFlagContext }
